import CustomInput from '../reusable/input';
import { useState } from 'react';
import { Box, Button, Chip } from '@mui/material';

interface AddAttendeesProps {
    attendees: string[];
    onAdd: (email: string) => void;
    onRemove: (email: string) => void;
}

const AddAttendeesComponent = ({ attendees, onAdd, onRemove }: AddAttendeesProps) => {
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');

    const validateEmail = (email: string) => (/^[^\s@]+@[^\s@]+\.[^\s@]+$/u).test(email);

    const handleAddChip = () => {
        if (!inputValue.trim()) {
            setError('Input cannot be empty.');
            return;
        }
        if (!validateEmail(inputValue)) {
            setError('Invalid email format.');
            return;
        }
        if (attendees.includes(inputValue)) {
            setError('This email is already added.');
            return;
        }

        onAdd(inputValue);
        setInputValue('');
        setError('');
    };

    return (
        <Box my={2}>
            <Box mb={1}>
                <CustomInput
                    label="Email"
                    placeholder="Enter email"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    error={Boolean(error)}
                    errorText={error}
                    fullWidth
                />
            </Box>
            <Button variant="contained" color="primary" onClick={handleAddChip} fullWidth>
                Add Attendee
            </Button>
            <Box mt={2} display="flex" gap="10px" flex="wrap">
                {attendees.map((attendee, index) => (
                    <Chip
                        key={index}
                        label={attendee}
                        color="default"
                        size="small"
                        onDelete={() => onRemove(attendee)}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default AddAttendeesComponent;
